import {
  ActionTypes as appActionTypes,
  getAllNationalTopics,
  setNavReferrer,
  setNewNationalTopics,
} from './app';

import {
  ActionTypes as electionActionTypes,
  adminApproveElection,
  adminUnapproveElection,
  clearElections,
  clearSelectedElection,
  createElection,
  getAllElections,
  getAllFromAddress,
  getAllApprovedElections,
  getAllUnapprovedElections,
  searchElections,
  setSelectedElection,
} from './election';

import {
  ActionTypes as raceActionTypes,
  adminApproveRace,
  adminUnapproveRace,
  clearSelectedRace,
  createRace,
  fetchRace,
  getAllApprovedRaces,
  getAllUnapprovedRaces,
  setRaceTopicMeaning,
  setSelectedRace,
} from './race';

import {
  ActionTypes as candidateActionTypes,
  adminApproveCandidate,
  adminUnapproveCandidate,
  clearSelectedCandidate,
  createCandidate,
  fetchCandidate,
  getAllApprovedCandidates,
  getAllUnapprovedCandidates,
  setSelectedCandidate,
} from './candidate';

import {
  ActionTypes as userActionTypes,
  getUserFromStorage,
  login,
  removeElectionFromUser,
  saveElectionToUser,
  setQueriedAddress,
  setUserNatlTopicQuizScores,
  setUserQuizScores,
  setUserRaceQuizScores,
  setUserSeenAddressPrompt,
  signOut,
  signUp,
  updateUser,
} from './user';

import {
  ActionTypes as flaggedLinksActionTypes,
  getAllFlaggedLinks,
  createFlaggedLink,
  deleteFlaggedLink,
} from './flagged-link';

import {
  ActionTypes as turnoutActionTypes,
  getAllVoterTurnoutData,
} from './turnout';

import {
  ActionTypes as roleActionTypes,
  fetchAllRoles,
  setSelectedRole,
  clearSelectedRole,
} from './role';

import {
  ActionTypes as flaggedTopicActionTypes,
  adminApproveFlaggedTopic,
  createFlaggedTopic,
  deleteFlaggedTopic,
  fetchAllTopicsForRace,
  getAllFlaggedTopics,
} from './flagged-topic';

const ActionTypes = {
  ...appActionTypes,
  ...candidateActionTypes,
  ...electionActionTypes,
  ...flaggedLinksActionTypes,
  ...flaggedTopicActionTypes,
  ...raceActionTypes,
  ...turnoutActionTypes,
  ...roleActionTypes,
  ...userActionTypes,
};

export {
  ActionTypes,
  adminApproveCandidate,
  adminApproveElection,
  adminApproveFlaggedTopic,
  adminApproveRace,
  adminUnapproveCandidate,
  adminUnapproveElection,
  adminUnapproveRace,
  clearElections,
  clearSelectedCandidate,
  clearSelectedElection,
  clearSelectedRace,
  clearSelectedRole,
  createCandidate,
  createElection,
  createFlaggedLink,
  createFlaggedTopic,
  createRace,
  deleteFlaggedLink,
  deleteFlaggedTopic,
  fetchAllRoles,
  fetchAllTopicsForRace,
  fetchCandidate,
  fetchRace,
  getAllApprovedCandidates,
  getAllApprovedElections,
  getAllApprovedRaces,
  getAllElections,
  getAllFlaggedLinks,
  getAllFlaggedTopics,
  getAllFromAddress,
  getAllNationalTopics,
  getAllUnapprovedCandidates,
  getAllUnapprovedElections,
  getAllUnapprovedRaces,
  getAllVoterTurnoutData,
  getUserFromStorage,
  login,
  removeElectionFromUser,
  saveElectionToUser,
  searchElections,
  setNavReferrer,
  setNewNationalTopics,
  setQueriedAddress,
  setRaceTopicMeaning,
  setSelectedCandidate,
  setSelectedElection,
  setSelectedRace,
  setSelectedRole,
  setUserNatlTopicQuizScores,
  setUserQuizScores,
  setUserRaceQuizScores,
  setUserSeenAddressPrompt,
  signOut,
  signUp,
  updateUser,
};
